import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, Loading } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {LoggerService} from '../../../shared/logger.service'
import { Storage } from '@ionic/storage';
import { ecomUserApi } from '../../../api/ecom/ecomUserApi';
import {ApiConfig} from '../../../shared/api-config.service'
import {AppConfig} from '../../../shared/app-config.service'
import {ValidationService} from '../../../shared/validation.service'
import { Observable } from 'rxjs/Observable';
import { CreateEarnerRequest } from '../../../api/swagger/ecomApi';
import { LoginPage } from '../../../pages/pages';
import {GlobalErrorService} from '../../../shared/global-error.service'


@Component({
    selector: 'page-register',
    templateUrl: 'register.html',
    providers: [ecomUserApi, ApiConfig, LoggerService,AppConfig, ValidationService,GlobalErrorService]
  })

  export class RegisterPage {
    registerForm: FormGroup;
    matchPass: boolean;
    submitAttempt: boolean = false;
    showFailed: boolean = false;
    PasswordRegex: any = "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";


    constructor(
      private navCtrl: NavController, 
      private ecomUserApi: ecomUserApi, 
      private formBuilder: FormBuilder, 
      private errorCtrl: GlobalErrorService,
      private loadingCtrl: LoadingController, 
      private alertCtrl: AlertController,
      private log: LoggerService,
      private storage: Storage,
      private val: ValidationService,
    )    
        {
          this.registerForm = formBuilder.group({
            forename: ['', Validators.required],
            surname: ['', Validators.required],            
            email: ['', Validators.required],
            password: ['', Validators.compose([Validators.required])],
            confirmPassword: ['', Validators.compose([Validators.required])]
        });
        }




      registerSave(){

        this.submitAttempt = true;

        if (!this.registerForm.valid) {
            this.log.debug("Not valid");
            this.checkPasswords(false);
        } else {
            this.checkPasswords(true);
        }


       
      }

      submitRegistration(){
        if(this.registerForm.valid){
          let loader = this.loadingCtrl.create();
          loader.present().then(() => {
              var registerModel = new CreateEarnerRequest({
                id : 0,
                name : this.registerForm.value.forename.trim() + " " + this.registerForm.value.surname.trim(),
                email : this.registerForm.value.email.trim(),
                //originatorReference : this.registerForm.value.company,
                password : this.registerForm.value.password.trim()
              });
  
              this.ecomUserApi.CreateEarner(registerModel).subscribe(
                result => {
                  if(result == true){
                    console.log(result);
                    this.showFailed = false;
                    this.navCtrl.push(LoginPage, true);
                  }
                  else if(result == false){
                    this.errorCtrl.presentToast("Your account could not be registered. Please check your details and try again");
                  }
                  else{
                    this.errorCtrl.presentToast("There is already an account registered under this Email Address.");
                  }
                  loader.dismiss();
                },
                error => {
                  this.errorCtrl.presentToast("An account already exists with this Email address.");
                  this.log.error(error);              
                  loader.dismiss();
                }
              );  
          });
        }        
      }

      checkPasswords(skipSuccess: boolean) {
          let passVal = this.registerForm.controls['password'];
          let confirmPassVal = this.registerForm.controls['confirmPassword'];
  
          //check if passwords match
          if (this.val.matchingPasswords(passVal.value, confirmPassVal.value)) {
              this.matchPass = false; 
              this.submitRegistration(); 
          }
          else {
              this.passwordMatchFail(passVal, confirmPassVal);
          }
      }

      passwordMatchFail(passVal, confirmPassVal) {
        //if fail - reset maatchpass var and listen for changes on controls
        this.matchPass = true;

        var s1: Observable<any> = passVal.valueChanges;
        var s2: Observable<any> = confirmPassVal.valueChanges;

        s1.merge(s2).forEach(
            (value: string) => {
                this.matchPass = false;
            }
        );
    }   

    
	

  }


// WEBPACK FOOTER //
// ./src/pages/authorization/register/register.ts